import Hero from './Hero';
import TrialResultsComponent from './TrialResultsComponent';
import MissionAndValuesSection from 'components/MissionAndValuesSection';
import { homepageData } from 'components/MissionAndValuesSection/mockData';
import LatestNews from './LatestNews';
import Solutions from './Solutions';
import AboutUs from './AboutUs';
import Products from './Products';
import Instagram from './Instagram';
import { CTAFormSection } from 'components/formSections/CTAFormSection';

export const Homepage = () => (
    <>
        <Hero />
        <Solutions />
        <AboutUs />
        <MissionAndValuesSection data={homepageData} />
        <Products />
        <TrialResultsComponent />
        <LatestNews />
        <Instagram />
        <CTAFormSection />
    </>
);
